import { useDispatch } from 'react-redux';

import { addReturnDataLayerEvent } from 'app/store/thunks/addCalculationPageDataLayerEvent';
import { FormsConfigActions } from 'app/store/data/formsConfig';

export function useCalculationViewPageHeader() {
  const dispatch = useDispatch();

  const onBackToStartClick = () => {
    dispatch(
      addReturnDataLayerEvent({
        eventName: 'return_click',
        elementName: 'Przycisk Wróć',
        eventLocation: 'strona_kalkulacji',
        stepName: 'formularz_step_1',
      })
    );
    dispatch(FormsConfigActions.setFirstStepMode(true));
  };

  return { onBackToStartClick };
}
